import axios from "axios";
import { saveAs } from 'file-saver';

export default {
  data: () => ({
    downloading: false,
  }),
  methods: {
    download(file, label) {
      this.downloading = true;
      let fileExtension = file.split(".").pop();
      if (!fileExtension || !["png", "jpg"].includes(fileExtension))
      {
        fileExtension = "jpg";
      }
      // so that we can safely remove the Authorization header
      const customAxios = axios.create();
      delete customAxios.defaults.headers.common["Authorization"];

      customAxios({
        url: file,
        method: "GET",
        responseType: "blob",
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `${label}.${fileExtension}`);
          document.body.appendChild(link);
          link.click();
          this.downloading = false;
        })
        .catch((error) => {
          this.downloading = false;
        });
    },
    downloadBase64File(contentType, base64Data, fileName) {
      let blob = new Blob([atob(base64Data)], {type: `${contentType};charset=utf-8`});
      saveAs(blob, fileName);
    },
  },
};
